import axios from "axios";
import formatDate from "../../mixins/formatDate";
import CONSTANTS from "../../settings/constants";
import store from "../../store/index.js";

const getEvents = (filters) => {
  let events = [];

  // create array of currently active filters using id strings
  let allFilters = filters
    .filter((school) => school.id != "global")
    .map((school) => school.id);
  let allFiltersJoin = allFilters.join(",");

  let activeFilters = filters
    .filter((school) => school.value)
    .map((school) => school.id);

  let lastCalendarDate = formatDate(
    new Date(new Date().setFullYear(new Date().getFullYear() + 1))
  );
  let firstCalendarDate = formatDate(
    new Date(new Date().setFullYear(new Date().getFullYear() - 1))
  );

  let eventsApi = `${CONSTANTS.MIDDLEWARE}/events?ids=${allFiltersJoin}&startDate=${firstCalendarDate}&endDate=${lastCalendarDate}`;

  return new Promise(function(resolve) {
    if (activeFilters.length > 0) {
      //eslint-disable-next-line
      NativeJS.debugLog(`Calling ${eventsApi}`);
      let start = Date.now();
      axios
        .get(eventsApi)
        .then((response) => {
          let end = Date.now();
          let time = (end - start) / 1000;
          //eslint-disable-next-line
          NativeJS.debugLog(
            `${eventsApi} responded after ${time} seconds with a ${response.status} code`
          );
          //eslint-disable-next-line
          NativeJS.debugLog(
            `${eventsApi} Response body: ${JSON.stringify(
              response.data,
              null,
              2
            )}`
          );

          let filteredEvents = response.data.filter((school) =>
            activeFilters.includes(school.id)
          );
          // flatten the array of schools newsletters into single array
          filteredEvents.forEach((schoolEvent) => {
            let eventItems =
              schoolEvent.events && schoolEvent.events.length > 0
                ? schoolEvent.events
                : [];
            events = [...events, ...eventItems];
          });

          resolve(events);
        })
        .catch((error) => {
          //eslint-disable-next-line
          NativeJS.debugLog(
            `error calling ${eventsApi}: ${JSON.stringify(error, null, 2)}`
          );
        });
    } else {
      resolve(events);
    }
  });
};

const getIndividualEvent = (id) => {
  const individualEventApi = `${CONSTANTS.MIDDLEWARE}/event?id=${id}`;

  return new Promise(function(resolve, reject) {
    let event = store.getters.events.find((event) => event.id === id);

    if (event) {
      resolve(event);
    } else {
      //eslint-disable-next-line
      NativeJS.debugLog(`Calling ${individualEventApi}`);
      let start = Date.now();
      axios
        .get(individualEventApi)
        .then((response) => {
          let end = Date.now();
          let time = (end - start) / 1000;
          //eslint-disable-next-line
          NativeJS.debugLog(
            `${individualEventApi} responded after ${time} seconds with a ${response.status} code`
          );
          //eslint-disable-next-line
          NativeJS.debugLog(
            `${individualEventApi} Response body: ${JSON.stringify(
              response.data,
              null,
              2
            )}`
          );

          resolve(response.data);
        })
        .catch((error) => {
          //eslint-disable-next-line
          NativeJS.debugLog(
            `error calling ${individualEventApi}: ${JSON.stringify(
              error,
              null,
              2
            )}`
          );
          reject(error);
        });
    }
  });
};

export default {
  getEvents,
  getIndividualEvent,
};
